

























import { defineComponent, computed } from "@vue/composition-api";
import { app, alarm, sensor } from "@/store";
import { ref } from "@vue/composition-api";

export default defineComponent({
    props: {
        armed: { type: Boolean, required: true }
    },
    setup(props) {
        const armedText = computed((): string => {
            return props.armed
                ? alarm.syncAlarm
                    ? "Disarming system"
                    : "System armed"
                : alarm.syncAlarm
                    ? "Arming system"
                    : "System disarmed";
        });
        const armedSubText = computed((): string => {
            return props.armed ? "Press to disarm" : "Press to arm";
        });
        const alarmSyncronising = computed(() => {
            return alarm.syncAlarm;
        });
        const doorClosed = computed<boolean>(() => {
            const d = sensor.devices?.find(x => x.attachedDeviceTypeId === 10) as any;
            const st = d?.status;
            return st === true ? false : st === false ? true : false;
        });
        const hatchClosed = computed<boolean>(() => {
            const d = sensor.devices?.find(x => x.attachedDeviceTypeId === 1) as any;
            const st = d?.status;
            return st === true ? false : st === false ? true : false;
        });
        const doorResponsive = computed<boolean>(() => {
            const d = sensor.devices?.find(x => x.attachedDeviceTypeId === 10) as any;
            return d?.responsive ?? false;
        });
        const hatchResponsive = computed<boolean>(() => {
            const d = sensor.devices?.find(x => x.attachedDeviceTypeId === 1) as any;
            return d?.responsive ?? false;
        });

        const toggleAlarm = () => {
            if (props.armed) {
                alarm.disarm();
            } else {
                const doorPaired = sensor.devices?.some(x => x.attachedDeviceTypeId === 10 && x.attachedDeviceId);
                const hatchPaired = sensor.devices?.some(x => x.attachedDeviceTypeId === 1 && x.attachedDeviceId);

                const doorOpen = !doorClosed.value;
                const hatchOpen = !hatchClosed.value;
                const doorUnresponsive = doorPaired ? !doorResponsive.value : false;
                const hatchUnresponsive = hatchPaired ? !hatchResponsive.value : false;

                const issues: string[] = [];

                if (doorPaired) {
                    if (doorUnresponsive) {
                        issues.push("the door is unresponsive");
                    } else if (doorOpen) {
                        issues.push("the door is open");
                    }
                }
                if (hatchPaired) {
                    if (hatchUnresponsive) {
                        issues.push("the hatch is unresponsive");
                    } else if (hatchOpen) {
                        issues.push("the hatch is open");
                    }
                }

                if (issues.length > 0) {
                    issues[0] = issues[0].charAt(0).toUpperCase() + issues[0].slice(1);
                    app.error = `${issues.join(", ")}.`;
                }

                alarm.arm();
            }
        };

        return {
            armedText,
            armedSubText,
            toggleAlarm,
            alarmSyncronising
        };
    }
});
